import { useContext, useEffect } from "react";
import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { defaultConfig } from "./default_config";
import { PivotControl } from "../../constants/pivot_control_options";
import { paramsToTransformArgs } from "./params_to_transform_args";
import { getDemandWalkSingleTableData } from "../../utils/mui_flat_table_data";
import { DemandPlanEditsContext } from "../../contexts/demand_plan_edits";

export const DemandPlanContainer = () => {
  const {
    plannerOverrideInputs,
    finalForecastInputs,
    yoyPercentageInputs,
    setPlannerOverrideInputs,
    setFinalForecastInputs,
    setYoYPercentageInputs,
    editMode,
  } = useContext(DemandPlanEditsContext);

  // Clear edit state when leaving the page so a stale override map can't leak
  // into the next session's save.
  useEffect(() => {
    return () => {
      setPlannerOverrideInputs({});
      setFinalForecastInputs({});
      setYoYPercentageInputs({});
    };
  }, [setPlannerOverrideInputs, setFinalForecastInputs, setYoYPercentageInputs]);

  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "sales_order_master",
        transformId: "demand_plan_editable",
        folder: "outputs",
        // Same menu label as "Demand Walk (Beta)" (/demand-walk-single), different
        // route — like Inventory Health's many URLs under one label.
        title: "Demand Walk",
        // Month + week grain only (no day). DateHierarchy renders the selector
        // from these keys; demand_plan_editable accepts both.
        dateHierarchyColumnFilter: {
          order_placed_month: "month",
          order_placed_week: "week",
        },
        excludedSegmentationsFilter: [],
        measureColumnFilter: {
          quantity: "quantity",
          revenue: "revenue",
        },
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.DateHierarchy,
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.Measure,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
          PivotControl.Download,
          PivotControl.EditModeToggle,
        ],
        paramsToTransformArgs: paramsToTransformArgs,
        // Grid container shared with Demand Walk (Beta), driven by demand_plan_edits
        // state so Save persists via saveDemandPlanLayerToDefaultSettings.
        demandWalkConfig: {
          plannerOverrideInputs,
          finalForecastInputs,
          yoyPercentageInputs,
          setPlannerOverrideInputs,
          setFinalForecastInputs,
          setYoYPercentageInputs,
          editMode: editMode,
          // Render persisted-override markers + hover from the
          // demand_plan_editable view columns. (Beta Demand Walk does not.)
          showPersistedOverrideMarkers: true,
        },
        getMatrix: getDemandWalkSingleTableData,
      }}
      defaultConfig={defaultConfig}
    />
  );
};
